export default __webpack_public_path__ + "static/media/wa_4.b99d0832.mp3";